export default [
  {
    path: "/settings/events",
    redirect: "/settings/events/eventTypeSettings",
    name: "eventsSettings",
    component: () => import("@/views/settings/events/EventSettings.vue"),
    meta: {
      action: "ROLE_CORE_CONSULTAR",
      resource: "ACL",
      pageTitle: "Eventos",
      breadcrumb: [
        {
          text: "Cadastros Módulo Eventos",
        },
      ],
    },
    children: [
      {
        path: "eventTypeSettings",
        name: "eventTypeSettings",
        component: () => import("@/views/settings/events/EventTypeSetting.vue"),
        meta: {
          pageTitle: "Tipo de Evento",
          action: "ROLE_CORE_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Cadastros Módulo Eventos | Tipo de Evento",
            },
          ],
        },
      },
      {
        path: "eventTypeFieldSettings",
        name: "eventTypeFieldSettings",
        component: () =>
          import("@/views/settings/events/EventTypeFieldSetting.vue"),
        meta: {
          pageTitle: "Campo Tipo de Evento",
          action: "ROLE_CORE_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Cadastros Módulo Eventos | Campo Tipo de Evento",
            },
          ],
        },
      },
      {
        path: "eventDiscountSettings",
        name: "eventDiscountSettings",
        component: () =>
          import("@/views/settings/events/EventDiscountSetting.vue"),
        meta: {
          pageTitle: "Descontos de Evento",
          action: "ROLE_CORE_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Cadastros Módulo Eventos | Descontos de Evento",
            },
          ],
        },
      },
      {
        path: "eventTaskSettings",
        name: "eventTaskSettings",
        component: () => import("@/views/settings/events/EventTaskSetting.vue"),
        meta: {
          pageTitle: "Tarefas de Evento",
          action: "ROLE_CORE_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Cadastros Módulo Eventos | Tarefas de Evento",
            },
          ],
        },
      },
      {
        path: "eventManagerSettings",
        name: "eventManagerSettings",
        component: () =>
          import("@/views/settings/events/EventManagerSetting.vue"),
        meta: {
          pageTitle: "Responsáveis por Evento",
          action: "ROLE_CORE_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Cadastros Módulo Eventos | Responsáveis por Evento",
            },
          ],
        },
      },
      {
        path: "eventParticipantSettings",
        name: "eventParticipantSettings",
        component: () =>
          import("@/views/settings/events/EventParticipantSetting.vue"),
        meta: {
          pageTitle: "Participantes de Evento",
          action: "ROLE_CORE_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Cadastros Módulo Eventos | Participantes de Evento",
            },
          ],
        },
      },
      {
        path: "eventFieldSettings",
        name: "eventFieldSettings",
        component: () =>
          import("@/views/settings/events/EventFieldSetting.vue"),
        meta: {
          pageTitle: "Campos de Evento",
          action: "ROLE_CORE_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Cadastros Módulo Eventos | Campos de Evento",
            },
          ],
        },
      },
    ],
  },
];
